import { render } from "./InAppBrowser.vue?vue&type=template&id=35eade30"
import script from "./InAppBrowser.vue?vue&type=script&lang=js"
export * from "./InAppBrowser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__